// What /Round/GetRound answers with. Mirrors Initiator/Models/RoundResponse.cs.
interface RoundResponse {
    players: Participant[];
    monsters: Participant[];
    elements: ElementInfo[];
    roundNumber: number;
    version: number;
    epoch: number;
}
